import { native } from '@forest/native-services'

// Fire-and-forget analytics events over the native bridge. Event names and
// firing semantics are contract: see GLOSSARY.md "Shop analytics names".

type ShopPageName = 'shop_classic' | 'shop_featured' | 'shop_top_up'

type ShopComponentName =
  | `shop_product_dialog_${number}`
  | 'shop_coin_3x_try_plus'
  | 'shop_coin_3x_subscribe_plus'

export function logPageView(pageName: ShopPageName) {
  void native.general.logEvent({
    event_name: 'page_view',
    event_params: { page_name: pageName },
  })
}

export function logComponentShow(componentName: ShopComponentName) {
  void native.general.logEvent({
    event_name: 'component_show',
    event_params: { component_name: componentName },
  })
}

export function logButtonClick(componentName: ShopComponentName) {
  void native.general.logEvent({
    event_name: 'component_event',
    event_params: {
      type: 'btn',
      app_action: 'click',
      component_name: componentName,
    },
  })
}

export function logProductPurchaseSuccess(productId: number) {
  void native.general.logEvent({
    event_name: 'store_product_purchase_success',
    event_params: { product_id: String(productId) },
  })
}
